module.exports = __webpack_public_path__ + "mk.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/mk.svg
// module id = 944
// module chunks = 0